'use strict';

// React-19 modernisation (Phase 4.7): react-redux-form originally passed the
// form `model` (and optional `localStore`) down to <Control>/<Field> via the
// LEGACY context API (getChildContext / childContextTypes / contextTypes),
// which React 19 removes. This is the single modern Context that replaces it.
// <Form>/<Fieldset> provide it; resolve-model consumes it. Shape: { model, localStore }.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var ModelContext = _react.createContext({ model: undefined, localStore: undefined });

ModelContext.displayName = 'RRFModelContext';

exports.default = ModelContext;
